import Layout from '@layout/Index'

export const appPopup = [
  {
    path: '/app-popup',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "app-popup-table" */ './pages/AppPopupTable.vue'),
        meta: {
          title: 'APP浮窗管理列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "app-popup-form" */ './pages/AppPopupForm.vue'),
        meta: {
          title: '添加APP浮窗管理',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "app-popup-form" */ './pages/AppPopupForm.vue'),
        meta: {
          title: '修改APP浮窗',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "app-popup-detail" */ './pages/AppPopupForm.vue'),
        meta: {
          title: 'APP浮窗配置详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/app-popup/app-popup.route.js